const Theme = {
  light: "light",
  dark: "dark",
  highContrast: "highContrast",
};

export default Theme;
